<template>
  <master-layout>
    <div class="bg-grey-5 min-h-screen">
      <BackButton variant="inline" data-test-id="gensapp-experiencesignup-back" @click="back" />
      <div
        class="font-aktiv-grotesk w-full md:max-w-[506px] md:mx-auto px-[24px] md:px-0 lg:px-0 pb-[32px]"
      >
        <div class="fixed bottom-0 z-50">
          <CheatConsole v-if="isNonProd"></CheatConsole>
        </div>

        <section class="flex flex-row mb-3">
          <h1 class="page-title mb-[4px]">Submit Preferences</h1>
        </section>

        <div class="flex flex-col items-center w-full">
          <div class="bg-white shadow-md pl-4 py-6 rounded-xl mb-6 w-full">
            <h1 class="text-[20px] font-aktiv-grotesk-medium mb-3 pr-4">
              Custom Experiences Preferences
            </h1>
            <div
              v-for="(exp, index) in pending_signups"
              :key="index"
              class="font-aktiv-grotesk-regular flex mb-2"
            >
              <div
                class="w-[48px] font-aktiv-grotesk-medium bg-[#FF660026] text-orange p-2 text-[14px] leading-[10px] text-center rounded-xl mr-2"
              >
                {{ getRankingNumber(index + 1) }}
              </div>
              {{ exp.name }}
            </div>
          </div>
          <div class="pb-6 flex flex-col gap-3 w-full">
            <!-- Read-only reminder of the single-experience choice (copied from MyExperienceSection) -->
            <div
              v-if="singleExpEnabled"
              class="flex items-center gap-6 p-4 bg-white border border-[#B3B3B3] rounded-lg"
            >
              <p
                class="flex-1 font-aktiv-grotesk-regular text-[16px] leading-[24px] text-[#666666]"
              >
                I would like to only attend 1 Experience
              </p>
              <img
                v-if="singleExperienceOnly"
                src="/assets/icons/checkbox-checked-circle-disabled.svg"
                class="w-5 h-5 flex-shrink-0"
              />
              <div
                v-else
                class="w-5 h-5 flex-shrink-0 rounded-full border border-[#B3B3B3] bg-white"
              />
            </div>
            <p>
              You'll be allocated to
              <span class="font-bold">{{
                singleExpEnabled && singleExperienceOnly ? 1 : this.mainExpData.allocatedExpsNo
              }}</span>
              Custom Experiences based on your preferences!
            </p>
          </div>
          <button
            class="font-aktiv-grotesk-trial block w-full mx-auto max-w-[295px] rounded-[100px] text-white text-[20px] leading-[24px] text-center py-[12px] mb-4 bg-orange hover:bg-[#F27521] cursor-pointer"
            data-event-tracking="gensapp-experiences-submitpreferences-button"
            @click="signed() && getModalShow()"
          >
            Submit
          </button>
        </div>
        <InterestModal
          :getExpAlloc="getExpAlloc()"
          :show="showModal"
          @close-modal="closeModal"
        ></InterestModal>
      </div>
    </div>
  </master-layout>
</template>
<script>
import momentts from 'moment-timezone';
import { mapActions, mapGetters, mapState } from 'vuex';
import InterestModal from '../../components/ExperiencePage/InterestModal.vue';
import axios from 'axios';
import platformMixin from '@/mixins/platformMixin';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
import BackButton from '@/components/common/BackButton.vue';

export default {
  name: 'ExpSummary',
  mixins: [platformMixin],
  components: { InterestModal, BackButton },
  data() {
    return {
      showModal: false,
      showCancelModal: false,
    };
  },
  computed: {
    ...mapGetters('signup', ['CG_SIGN_UP_CLOSE_TS', 'SINGLE_EXP_ENABLE']),
    ...mapGetters('profile', ['type']),
    singleExpEnabled() {
      // Sysparam kill switch: show unless the server explicitly sets SINGLE_EXP_ENABLE to 0.
      const flag = this.SINGLE_EXP_ENABLE;
      return flag !== '0' && flag !== 0 && flag !== false;
    },
    ...mapState('signup', [
      'signups',
      'pending_signups',
      'EXP_ALLOC_TS',
      'mainExpData',
      'singleExperienceOnly',
    ]),
    ...mapState('user', ['token']),
  },
  methods: {
    ...mapActions('signup', ['setSignupState', 'setBackFromSummary']),
    getModalShow() {
      this.showModal = !this.showModal;
    },
    closeModal() {
      this.showModal = false;
    },
    async signed() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'gensapp-experiences-submitpreferences-button',
          page: 'experience',
        },
      });
      const expTypeList = this.pending_signups.map(element => element.type);

      const { status, data } = await axios.request(process.env.VUE_APP_API_URL + '/exps/signup', {
        method: 'post',
        // change to receive a list of exp types
        // data: { types: ["CG", "MD", "DSN"] },
        data: { types: expTypeList, singleExperienceOnly: this.singleExperienceOnly },
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });
      if (status !== 201) location.reload();
      this.setSignupState(data);

      this.$emit('sign-up');
    },

    back() {
      this.$router.go(-1);
      this.setBackFromSummary(true);
    },
    getRankingNumber(i) {
      const j = i % 10,
        k = i % 100;
      if (j === 1 && k !== 11) {
        return i + 'st';
      }
      if (j === 2 && k !== 12) {
        return i + 'nd';
      }
      if (j === 3 && k !== 13) {
        return i + 'rd';
      }
      return i + 'th';
    },
    getExpAlloc() {
      momentts.tz.setDefault('Asia/Singapore');
      const dayStr = momentts(this.EXP_ALLOC_TS).format('dddd, D MMMM');
      const timeStr = momentts(this.EXP_ALLOC_TS).format('ha');
      return dayStr + ' at ' + timeStr;
    },
  },
};
</script>
